'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useFormatter, useLocale } from 'next-intl';
import type { BlogPost } from './BlogList';

interface BlogCardClientProps {
  post: BlogPost;
}

export function BlogCardClient({ post }: BlogCardClientProps) {
  const locale = useLocale();
  const format = useFormatter();
  const formattedDate = format.dateTime(new Date(post.date), {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });

  return (
    <Link href={`/${locale}/blog/${post.slug}`} target="_blank" prefetch={false} className="group block h-full w-full">
      <div className="flex h-full w-full flex-col overflow-hidden rounded-[1.25rem] border border-black/10">
        <div className="aspect-[4/3] w-full flex-shrink-0 overflow-hidden">
          <Image
            src={post.coverImage}
            alt={post.coverImageAlt || post.title}
            width={800}
            height={600}
            className="h-full w-full rounded-[1.25rem] bg-system-black/5 object-cover object-center transition-transform duration-300"
            draggable="false"
            placeholder="blur"
            blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
          />
        </div>
        <div className="m-[24px] flex flex-1 flex-col justify-between md:m-[13px]">
          <div className="line-clamp-4 w-full flex-shrink-0 font-semibold text-black text-lg leading-[140%] transition-colors duration-300 group-hover:text-[#3993d3] md:text-xs md:leading-[140%]">
            {post.title}
          </div>
          <div className="text-black/[.80] leading-[140%]">
            <time className="text-black/80 leading-[140%] md:text-xs">{formattedDate}</time>
          </div>
        </div>
      </div>
    </Link>
  );
}
